module.exports = __webpack_public_path__ + "static/media/Appmobile.c27467aa.png";